var map = {
	"./medicina-legale-sapienza-2012-2013.json": 2437,
	"./medicina-legale-sapienza-2013-2014.json": 1885,
	"./medicina-legale-sapienza-2014-2015.json": 7685,
	"./medicina-legale-sapienza-2016-2017.json": 1533,
	"./medicina-legale-sapienza-2017-2018.json": 1925,
	"./medicina-legale-sapienza-2023.json": 5536,
	"./medicina-legale-tor-vergata-2022.json": 3464,
	"./medicina-legale-tor-vergata-2024.json": 6246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4902;